import { getInitialMinBookingTime } from './get_initial_min_booking_time'
import { getInitialMinBookingTimeType } from './get_initial_min_booking_time_type'

export const getInitialValue = ({ min_booking_time: minBookingTime }) => ({
  minBookingTime: minBookingTime === null ? '' : getInitialMinBookingTime(minBookingTime),
  minBookingTimeType: minBookingTime === null ? 'mins' : getInitialMinBookingTimeType(minBookingTime),
})
